import { request } from 'apis/request';
import urls from 'apis/configure/urls';

const { apiUrlV1 } = urls;
export default function fetchStore({ id }) {
  return request.get(`${apiUrlV1}/store/${id}/`);
}
